import "./chart.css"
import * as RechartsPrimitive from "recharts"
import Chart from "./Chart"
import ChartAxis from "./ChartAxis"
import ChartGrid from "./ChartGrid"
import ChartCompossed from "./ChartCompossed"
import ChartBar from "./ChartBar"
import ChartLine from "./ChartLine"
import ChartArea from "./ChartArea"
import { ChartTooltip, ChartTooltipContent } from "./base/ChartBaseTooltip"
import ChartTooltipFloating from "./ChartTooltipFloating"
import { ChartLegend, ChartLegendContent } from "./base/ChartBaseLegend"
import CustomBarMarker from "./CustomBarMarker"
import ChartPie from "./ChartPie"
import ChartGradient from "./ChartGradient"

export type { ChartConfig as ChartConfigType } from "./base/chartBase.context"
export {
  computeChartYAxisDomainAndTicks,
  type ChartYAxisDomainAndTicks,
} from "./chart.utils"

export default Object.assign(Chart, {
  // Recharts primitives mapped to Chart object
  BarChart: RechartsPrimitive.BarChart,
  AreaChart: RechartsPrimitive.AreaChart,
  LineChart: RechartsPrimitive.LineChart,
  ComposedChart: RechartsPrimitive.ComposedChart,
  PieChart: RechartsPrimitive.PieChart,
  ScatterChart: RechartsPrimitive.ScatterChart,

  // CHART BASIC COMPONENTS - (Building blocks of the chart)
  Legend: ChartLegend,
  LegendContent: ChartLegendContent,
  Tooltip: ChartTooltip,
  TooltipContent: ChartTooltipContent,
  TooltipFloating: ChartTooltipFloating,
  Axis: ChartAxis,
  Grid: ChartGrid,

  // CHART COMPONENTS - (Actual chart elements like bars, lines, and areas)
  Line: ChartLine,
  Bar: ChartBar,
  Area: ChartArea,
  Pie: ChartPie,
  Scatter: RechartsPrimitive.Scatter,

  // Additional composed chart components
  Compossed: ChartCompossed,
  LabelList: RechartsPrimitive.LabelList,
  Label: RechartsPrimitive.Label,
  ReferenceArea: RechartsPrimitive.ReferenceArea,
  CustomBarMarker: CustomBarMarker,
  BarCell: RechartsPrimitive.Cell, // Individual cells inside bars
  Gradient: ChartGradient,
})
